export default __webpack_public_path__ + "a2ef1a161e26e5967109431c45809fe4.webp";